import { render, staticRenderFns } from "./FooterModule.vue?vue&type=template&id=0484a2e4&scoped=true"
import script from "./FooterModule.vue?vue&type=script&lang=js"
export * from "./FooterModule.vue?vue&type=script&lang=js"
import style0 from "./FooterModule.vue?vue&type=style&index=0&id=0484a2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484a2e4",
  null
  
)

export default component.exports